











































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import Session from '@/app/module/session'

@Component
export default class MapMarker extends Vue {
  private options:any = {
    strokeColor: '',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '',
    fillOpacity: 0.35
  }
  private fieldServerIcon: any = {
    url: require('@/assets/icon/ico_spws.png'),
    size: { width: 25, height: 25, f: 'px', b: 'px' },
    scaledSize: { width: 25, height: 25, f: 'px', b: 'px' }
  }
  private paddyWatchIcon: any = {
    url: require('@/assets/icon/ico_paddy_watch.png'),
    size: { width: 25, height: 25, f: 'px', b: 'px' },
    scaledSize: { width: 25, height: 25, f: 'px', b: 'px' }
  }
  private fieldComIcon: any = {
    url: require('@/assets/icon/ico_fieldcam.png'),
    size: { width: 25, height: 25, f: 'px', b: 'px' },
    scaledSize: { width: 25, height: 25, f: 'px', b: 'px' }
  }
  private canonIcon: any = {
    url: require('@/assets/icon/ico_canon.png'),
    size: { width: 25, height: 25, f: 'px', b: 'px' },
    scaledSize: { width: 25, height: 25, f: 'px', b: 'px' }
  }

  /* computed */
  private get fieldChoiceState (): number {
    return this.$store.state.fieldChoiceState.id
  }
  private get modalFieldChoiceState (): string {
    return this.$store.state.fieldChoiceState.modalId
  }
  private get spFieldChoiceState (): string {
    return this.$store.state.spFieldState.choiceFieldId
  }

  @Watch('fieldChoiceState')
  onIdChange (newValue: string) {
    if (parseInt(newValue) === this.data.id) {
      this.options.strokeColor = '#ed8f33'
      this.options.fillColor = '#ed8f33'
    } else {
      if (this.data.fillColor === undefined && this.data.strokeColor !== undefined) {
        this.data.fillColor = this.data.strokeColor
      } else if (this.data.strokeColor === undefined && this.data.fillColor !== undefined) {
        this.data.strokeColor = this.data.fillColor
      } else if (this.data.strokeColor === undefined && this.data.fillColor === undefined) {
        this.data.strokeColor = '#FF3535'
        this.data.fillColor = '#FF3535'
      }
      this.options.strokeColor = this.data.strokeColor
      this.options.fillColor = this.data.fillColor
    }
  }
  @Watch('modalFieldChoiceState')
  onModalIdChange (newValue: string) {
    if (parseInt(newValue) === this.data.id) {
      this.options.strokeColor = '#ed8f33'
      this.options.fillColor = '#ed8f33'
    } else {
      if (this.data.fillColor === undefined && this.data.strokeColor !== undefined) {
        this.data.fillColor = this.data.strokeColor
      } else if (this.data.strokeColor === undefined && this.data.fillColor !== undefined) {
        this.data.strokeColor = this.data.fillColor
      } else if (this.data.strokeColor === undefined && this.data.fillColor === undefined) {
        this.data.strokeColor = '#FF3535'
        this.data.fillColor = '#FF3535'
      }
      this.options.strokeColor = this.data.strokeColor
      this.options.fillColor = this.data.fillColor
    }
  }
  @Watch('spFieldChoiceState')
  onSpIdChange (newValue: string) {
    if (parseInt(newValue) === this.data.id) {
      this.options.strokeColor = '#ed8f33'
      this.options.fillColor = '#ed8f33'
    } else {
      if (this.data.fillColor === undefined && this.data.strokeColor !== undefined) {
        this.data.fillColor = this.data.strokeColor
      } else if (this.data.strokeColor === undefined && this.data.fillColor !== undefined) {
        this.data.strokeColor = this.data.fillColor
      } else if (this.data.strokeColor === undefined && this.data.fillColor === undefined) {
        this.data.strokeColor = '#FF3535'
        this.data.fillColor = '#FF3535'
      }
      this.options.strokeColor = this.data.strokeColor
      this.options.fillColor = this.data.fillColor
    }
  }

  @Prop() private data!:any

  created () {
    if (Object.keys(this.data.path).length !== 0) {
      /*
       * 両方ない場合は赤、片方のみがない場合はそれぞれの色を入れる
       */
      if (this.data.fillColor === undefined && this.data.strokeColor !== undefined) {
        this.data.fillColor = this.data.strokeColor
      } else if (this.data.strokeColor === undefined && this.data.fillColor !== undefined) {
        this.data.strokeColor = this.data.fillColor
      } else if (this.data.strokeColor === undefined && this.data.fillColor === undefined) {
        this.data.strokeColor = '#FF3535'
        this.data.fillColor = '#FF3535'
      }

      this.options.strokeColor = this.data.strokeColor
      this.options.fillColor = this.data.fillColor
    }

    if (parseInt(Session.getChoiceFieldId()!) === this.data.id) {
      this.options.strokeColor = '#ed8f33'
      this.options.fillColor = '#ed8f33'
    } else {
      this.options.strokeColor = this.data.strokeColor
      this.options.fillColor = this.data.fillColor
    }
  }

  private click (id: string) {
    if (this.$route.path === '/field') {
      this.$store.commit('fieldChoiceState/setChoosingFieldId', String(id))
    } else if (this.$route.path === '/sp/field') {
      this.$store.commit('spFieldState/setChoiceField', String(id))
    } else {
      this.$store.commit('fieldChoiceState/setChoosingModalFieldId', id)
    }
  }

  private toAgri () {
    if (this.$route.path !== '/sp/field') {
      this.$emit('show-confirm-modal')
    }
  }
}
